/**
 * PatternObservations — Strategy Insights section 1.
 * Pattern observations from dev_events + decision-history aggregations.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { DS_COLORS, DS_SPACING, DS_TYPOGRAPHY } from '@/config/ui-invariants';
import { copy } from '@/content/copy';
import { SectionRegenWrap } from '@/components/strategy-insights/SectionRegenWrap';

export function PatternObservations({ patterns = [], onResynth }) {
  return (
    <SectionRegenWrap title={copy.strategyInsights.sections.patterns} defaultOpen onResynth={onResynth}>
      {patterns.length === 0 ? (
        <p style={{ ...DS_TYPOGRAPHY.bodyMd, color: DS_COLORS.text.secondary, margin: 0 }}>
          {copy.strategyInsights.empty.patterns}
        </p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: DS_SPACING.paragraphSpacing }}>
          {patterns.map((p) => (
            <div key={p.id} data-regen-key={p.id}>
              <h3
                style={{
                  ...DS_TYPOGRAPHY.listItemTitle,
                  color: DS_COLORS.text.primary,
                  margin: `0 0 ${DS_SPACING.labelToContent}px 0`,
                }}
              >
                {p.title}
              </h3>
              <p style={{ ...DS_TYPOGRAPHY.bodyMd, color: DS_COLORS.text.primary, margin: 0 }}>
                {p.description}
              </p>
            </div>
          ))}
        </div>
      )}
    </SectionRegenWrap>
  );
}

PatternObservations.propTypes = {
  patterns: PropTypes.array,
  onResynth: PropTypes.func,
};

export default PatternObservations;
